import { render, staticRenderFns } from "./PerfilConsumos.vue?vue&type=template&id=70910a44&scoped=true"
import script from "./PerfilConsumos.vue?vue&type=script&lang=js"
export * from "./PerfilConsumos.vue?vue&type=script&lang=js"
import style0 from "./PerfilConsumos.vue?vue&type=style&index=0&id=70910a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70910a44",
  null
  
)

export default component.exports